












import Vue from "vue";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import WidgetCard from "./WidgetCard.vue";

export default Vue.extend({
    components: {
        Dashboard,
        DashLayout,
        DashItem,
        WidgetCard,
    },
    data() {
        return {
            dlayouts: [
                {
                    breakpoint: "lg",
                    breakpointWidth: this.$vuetify.breakpoint.thresholds.md,
                    numberOfCols: 10,
                },
                {
                    breakpoint: "md",
                    breakpointWidth: this.$vuetify.breakpoint.thresholds.sm,
                    numberOfCols: 8,
                },
                {
                    breakpoint: "sm",
                    breakpointWidth: this.$vuetify.breakpoint.thresholds.xs,
                    numberOfCols: 4,
                },
                {
                    breakpoint: "xs",
                    breakpointWidth: 380,
                    numberOfCols: 2,
                },
            ],
        };
    },
    props: ["dashboard"],
});
